import { render, staticRenderFns } from "./TopicTableRow.vue?vue&type=template&id=033aae58&scoped=true"
import script from "./TopicTableRow.vue?vue&type=script&lang=js"
export * from "./TopicTableRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033aae58",
  null
  
)

export default component.exports